var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLinkBreak = function SvgIconLinkBreak(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.75 3.498c-1.26 0-2.47.5-3.36 1.392l-.685.684a1 1 0 0 0 1.414 1.414l.685-.684a2.752 2.752 0 1 1 3.892 3.892l-.685.684a1 1 0 1 0 1.415 1.415l.684-.685a4.752 4.752 0 0 0-3.36-8.112M10 4.5a1 1 0 0 0-2 0v1.875a1 1 0 0 0 2 0zm6 13.125a1 1 0 1 0-2 0V19.5a1 1 0 1 0 2 0zM3.5 9a1 1 0 0 1 1-1h1.875a1 1 0 0 1 0 2H4.5a1 1 0 0 1-1-1m14.125 5a1 1 0 1 0 0 2H19.5a1 1 0 1 0 0-2zm-12.05-2.295a1 1 0 1 1 1.413 1.415l-.684.684a2.752 2.752 0 1 0 3.892 3.892l.684-.684a1 1 0 0 1 1.415 1.414l-.685.684a4.752 4.752 0 1 1-6.72-6.72z",
    clipRule: "evenodd"
  })));
};
export default SvgIconLinkBreak;